document.addEventListener('DOMContentLoaded', function () {
    // ===========================
    // FILTER SECTION ARROWS
    // ===========================
    const filterPrev = document.getElementById('filterPrev');
    const filterNext = document.getElementById('filterNext');
    const filterTrack = filterPrev ? filterPrev.closest('.dashboard__filters-left').querySelector('.dashboard__filter-track') : null;
    const filterList = document.getElementById('filterList');
    const filterSearch = document.getElementById('filterSearch');
    const searchBtn = document.querySelector('.dashboard__filter-search-btn');

    if (filterPrev && filterNext && filterTrack && filterList) {
        const scrollAmount = 180;

        filterNext.addEventListener('click', function () {
            filterTrack.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        });

        filterPrev.addEventListener('click', function () {
            filterTrack.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        });

        // ===========================
        // DRAG TO SCROLL LOGIC
        // ===========================
        let isDown = false;
        let isDragging = false;
        let startX;
        let scrollLeft;

        filterTrack.addEventListener('mousedown', (e) => {
            isDown = true;
            isDragging = false;
            filterTrack.classList.add('active');
            startX = e.pageX - filterTrack.offsetLeft;
            scrollLeft = filterTrack.scrollLeft;
            filterTrack.style.cursor = 'grabbing';
            filterTrack.style.scrollBehavior = 'auto'; // Disable smooth scroll during drag
        });

        filterTrack.addEventListener('mouseleave', () => {
            isDown = false;
            filterTrack.classList.remove('active');
            filterTrack.style.cursor = 'grab';
        });

        filterTrack.addEventListener('mouseup', () => {
            isDown = false;
            filterTrack.classList.remove('active');
            filterTrack.style.cursor = 'grab';
            filterTrack.style.scrollBehavior = 'smooth'; // Restore smooth scroll
            // Small delay to allow 'click' events on buttons if no significant drag happened
            setTimeout(() => {
                isDragging = false;
            }, 50);
        });

        filterTrack.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            
            const x = e.pageX - filterTrack.offsetLeft;
            const walk = (x - startX) * 2; // Scroll speed multiplier
            
            // Re-detect if it was actually a drag (e.g., more than 5px)
            if (Math.abs(x - startX) > 5) {
                isDragging = true;
            }

            if (isDragging) {
                e.preventDefault();
                filterTrack.scrollLeft = scrollLeft - walk;
            }
        });

        // Initial cursor style
        filterTrack.style.cursor = 'grab';

        // Filter button active state
        const filterBtns = filterList.querySelectorAll('.dashboard__filter-btn');

        filterBtns.forEach(function (btn) {
            btn.addEventListener('click', function (e) {
                if (isDragging) {
                    e.preventDefault();
                    e.stopPropagation();
                    return;
                }
                filterBtns.forEach(function (b) { b.classList.remove('dashboard__filter-btn--active'); });
                this.classList.add('dashboard__filter-btn--active');
                
                // Trigger global course fetch if function exists
                if (window.fetchCourses) {
                    window.fetchCourses(1);
                }
            });
        });

        if (searchBtn) {
            searchBtn.addEventListener('click', function () {
                if (window.fetchCourses) {
                    window.fetchCourses(1);
                }
            });
        }

        if (filterSearch) {
            filterSearch.addEventListener('keyup', function (e) {
                if (e.key === 'Enter' || this.value.length === 0) {
                    if (window.fetchCourses) {
                        window.fetchCourses(1);
                    }
                }
            });
        }
    }
});
